module.exports = __webpack_public_path__ + "assets/img/idx.2d9ae02c.png";